/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskPolicyApproval,
  RiskPolicyApproval$inboundSchema,
} from "./riskpolicyapproval.js";

export type ListRiskPolicyApprovalsResult = {
  /**
   * Approval requests, newest first.
   */
  approvals: Array<RiskPolicyApproval>;
  /**
   * Pass as cursor to fetch the next page. Absent on the last page.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListRiskPolicyApprovalsResult$inboundSchema: z.ZodMiniType<
  ListRiskPolicyApprovalsResult,
  unknown
> = z.pipe(
  z.object({
    approvals: z.array(RiskPolicyApproval$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listRiskPolicyApprovalsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRiskPolicyApprovalsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRiskPolicyApprovalsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRiskPolicyApprovalsResult' from JSON`,
  );
}
